

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseReadOnlyService } from '../../../services/base-readonly.service';
import { BaseNotification } from './base-notification.model';

@Injectable({
    providedIn: 'root'
})
export class BaseNotificationService<T> extends BaseReadOnlyService<BaseNotification> {

    constructor(protected http: HttpClient, actionUrl: string) {
        super(http, actionUrl);
    }

    setAsRead(id: number) {
        return this.http.get<T>(this.baseUrl + '/setasread/' + id);
    }
}
